<template>
  <div>
    <b-row class="pl-2 pr-2">
      <b-col class="col-md-12 col-12">
        <div class="position-absolute tt-alert-block">
          <transition
            name="alert-slide-fade"
            leave-active-class="animate__animated animate__fadeOutUp"
          >
            <b-alert
              variant="success"
              size="lg"
              show=""
              v-if="deletingStatus === 'successDeletion'"
            >
              Trip was deleted successfully</b-alert
            >
          </transition>
          <transition
            name="alert-slide-fade"
            leave-active-class="animate__animated animate__fadeOutUp"
          >
            <b-alert
              variant="danger"
              size="lg"
              show=""
              v-if="deletingStatus === 'failedDeletion'"
            >
              There was a problem deleting the trip please try again.</b-alert
            >
          </transition>
        </div>
        <div v-if="!limit">
          <div>
            <h1 class="font-weight-500 text-center mt-3">Saved Trips</h1>
          </div>
        </div>
        <div class="mt-md-0 mb-5 tt-mt">
          <hr class="mb-4" v-if="!limit" />
          <b-col
            class="px-0 justify-content-center text-center d-flex"
            v-if="!limit"
          >
            <b-button
              :to="'/add-trip'"
              variant="warning"
              class="w-100 py-2 btn-new text-white mb-3 tt-border-radius"
              >Add a new Trip</b-button
            >
          </b-col>
          <b-list-group class="tt-border-radius">
            <b-list-group-item
              class="bg-primary text-white tt-border-radius border mb-1 mt-2"
              v-if="savedRecords.length > 0"
            >
              <div class="d-flex justify-content-between">
                <span> {{ limit ? "Saved Trips" : "Trip List" }}</span>
                <span v-if="limit"
                  ><router-link :to="{ name: 'trips' }" tag="span"
                    >View all trips</router-link
                  ></span
                >
              </div>
            </b-list-group-item>
            <b-list-group-item
              v-for="trip in savedRecords"
              :key="trip._id"
              class="text-left"
              :variant="!trip.is_business ? 'secondary' : ''"
            >
              <div class="row">
                <div class="text-left col-7 col-md-10">
                  <div class="d-flex mr-2">
                    <div>
                      <b-icon
                        icon="exclamation-circle-fill"
                        variant="warning"
                        class="m-2"
                        v-if="!trip.is_synced"
                      ></b-icon>
                      <b-icon
                        icon="check-circle-fill"
                        variant="success"
                        class="m-2"
                        v-else
                      ></b-icon>
                    </div>
                    <div>
                      {{ placesObj[trip.departure_location_id] }}
                      <b-icon icon="arrow-right" font-scale="1"></b-icon>
                      {{ placesObj[trip.arrival_location_id] }} :
                      <b v-if="trip.initial_odometer">
                        Distance:
                        {{ trip.final_odometer - trip.initial_odometer }} km</b
                      ><br />
                      <small>{{ trip.description }}</small
                      ><small> on {{ formatDate(trip.trip_time) }}</small
                      ><br />
                      <small v-if="carsArr[trip.vehicle_pouch_id]">{{
                        carsArr[trip.vehicle_pouch_id].is_default_car
                          ? "Default Car"
                          : carsArr[trip.vehicle_pouch_id].make +
                            " - " +
                            carsArr[trip.vehicle_pouch_id].model
                      }}</small>
                    </div>
                  </div>
                </div>
                <div class="col-5 col-md-2">
                  <div class="d-flex" style="justify-content: end">
                    <b-icon
                      alt="here"
                      scale="1.3"
                      icon="pencil"
                      class="mr-2"
                      variant="transparent"
                      @click="editTrip(trip)"
                    ></b-icon>
                    <b-icon
                      icon="x-circle-fill"
                      scale="1"
                      variant="danger"
                      v-b-modal.modal-center
                      modal-ok.delete
                      @click="selectedTrip = trip"
                    ></b-icon>
                  </div>
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-col>
      <b-modal
        id="modal-center"
        centered
        title="Delete"
        header-bg-variant="tt-bg"
      >
        <template>
          <p>Are you sure about this action ?</p>
        </template>

        <template #modal-footer="{ ok, cancel }">
          <b-button
            class="tt-button"
            @click="
              deleteTrip();
              ok();
            "
          >
            Delete
          </b-button>
          <b-button variant="danger" @click="cancel()">
            Cancel
          </b-button>
        </template>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment";

export default {
  name: "Trip",
  data() {
    return {
      editableTrip: "",
      selectedTrip: ""
    };
  },
  created() {
    // only fire action when component is viewed on its own
    this.$store.dispatch("trip/getTripsAction");
    this.$store.dispatch("auth/checkAuthAction");
  },
  props: {
    limit: {
      type: Boolean
    }
  },
  computed: {
    savedRecords() {
      try {
        return this.limit === true
          ? this.$store.state.trip.all.slice(0, 10)
          : this.$store.state.trip.all;
      } catch (e) {
        return {};
      }
    },
    ...mapGetters({
      carsArr: "car/getCarsArray",
      placesObj: "place/getAllPlaces"
    }),

    ...mapState({
      error: state => state.trip.actionErrorMsg,
      success: state => state.trip.actionSuccessMsg
    }),

    deletingStatus() {
      return this.error || this.success;
    }
  },
  watch: {
    deletingStatus: function() {
      this.$store.commit("place/clearMes");
    }
  },
  methods: {
    deleteTrip() {
      this.selectedTrip["status"] = 2;
      this.selectedTrip["is_synced"] = false;
      this.$store.commit("trip/markForDeletion", this.selectedTrip);
      this.$store.dispatch("trip/getTripsAction");
      this.$store.commit("sync/getUnsyncedRecords");
    },
    editTrip(trip) {
      //emit the new trip if user is currently editing another trip
      if (this.$route.name === "edit-trip") {
        this.$emit("changeEditedTrip", trip);
      } else {
        this.$router.push({
          name: "edit-trip",
          params: { editableTrip: trip }
        });
      }
    },
    formatDate(date) {
      return moment(date).format("lll");
    }
  }
};
</script>

<style scoped>
.badge {
  vertical-align: top;
}
</style>
